import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ColorsConstants } from 'src/app/shared/common';
import { NumberFormatPipe } from 'src/app/shared/pipes';

@Component({
  selector: 'app-statistics-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule, NumberFormatPipe],
  templateUrl: './statistics-card.component.html',
  styleUrls: ['./statistics-card.component.scss'],
})
export class StatisticsCardComponent implements OnInit {
  // inputs
  @Input() percentage: number = -2;
  @Input() statisticsPercent: number;
  @Input() statisticsLabel: string;
  @Input() cardHeaderLabel: string;
  @Input() backgroundColor = ColorsConstants.LIGHT_COLOR;

  // constants
  Math = Math;

  constructor() {}

  ngOnInit(): void {}
}
